module.exports = __webpack_public_path__ + "img/sfmd2.400d98e0.jpg";